export default __webpack_public_path__ + "static/developer-6b8523f5349c3381513bde94f2773c0e.png";